import React from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";
import logo from "../../img/logo1.png";

function Header() {
  return (
    <header>
      {/* top bar */}
      <div className="top-bar">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 contact-info">
              <a href="tel:+919880104505"><i className="fas fa-phone-alt icon"></i> +91 988 010 4505</a>
              <a href="mailto:info@rajucaterer.in"><i className="fas fa-envelope icon"></i> rajucaterer1@gmail.com</a>
            </div>
            <div className="col-lg-6 utility-links text-lg-end">
              <NavLink to="/contact" className={({ isActive }) =>isActive ? "nav-link active-link" : "nav-link" }>
                <i className="fas fa-user icon"></i> Contact Us
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      {/* navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          <NavLink className="navbar-brand logo" to="/">
            {/* <h2>Raju<span style={{ color: "#cf6511" }}>Caters</span></h2> */}
            <img src={logo} alt="Just BLR Logo" className="mb-3" style={{maxWidth: '180px'}} />
          </NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"> 
                <NavLink to="/"end className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>About</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/services" className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>Services</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/menu" className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>Menu</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/gallery" className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>Gallery</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/contact" className={({ isActive })=>isActive ? "nav-link active-link" : "nav-link"}>Contact</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
